import { useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";
import usePromoCodes from "@/hooks/promotions/usePromoCodes";
import toast from "react-hot-toast";

const useRemoveDiscountIfNeeded = () => {
	const cart = useSelector((state: AppState) => state.cart);
	const groupCart = useSelector((state: AppState) => state.group_cart);
	const activeCart = groupCart?.allowShopping === true;
	const { removePromo } = usePromoCodes();

	const removeDiscountIfNeeded = async () => {
		if (!activeCart && cart.discountedPrice !== 0 && cart.applied_promo_code) {
			await removePromo(cart.applied_promo_code);
			toast.remove();
			toast.success("Discount removed due to cart edit");
		}
		if (
			activeCart &&
			groupCart.discountedPrice !== 0 &&
			groupCart.applied_promo_code
		) {
			await removePromo(groupCart.applied_promo_code);
			toast.remove();
			toast.success("Discount removed due to cart edit");
		}
	};

	return removeDiscountIfNeeded;
};

export default useRemoveDiscountIfNeeded;
